import React from 'react'
import OperatorPhotosScreen from './OperatorPhotos'

const RobotPhotosScreen: React.FC = () => {
  return <OperatorPhotosScreen category="robot" />
}

export default RobotPhotosScreen
